import { useState, useEffect } from "react";
import { Plane } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import { motion, AnimatePresence } from "framer-motion";

export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 85vh)
      const heroHeight = window.innerHeight * 0.85;
      setIsVisible(window.scrollY > heroHeight);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-24 right-4 z-40 md:bottom-28 md:right-6"
        >
          <Button
            asChild
            size="lg"
            className="shadow-xl hover:shadow-2xl bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-6 h-12 font-semibold"
          >
            <NavLink to="/contact" className="flex items-center gap-2">
              <Plane className="h-5 w-5" />
              <span className="hidden sm:inline">Plan My Trip</span>
              <span className="sm:hidden">Plan Trip</span>
            </NavLink>
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
